// extracted by mini-css-extract-plugin
export default {"aquaTools":"AquaTools_aquaTools__wBMbP","leftColumn":"AquaTools_leftColumn__vZkXv","rightColumn":"AquaTools_rightColumn__zhAXB"};